import PropTypes from 'prop-types';
import React from 'react';
import style from './TacticRow.module.css';
import { Body3 } from '../../../../../../../../atomic/text/Text';
import { colors } from '../../../../../../../../../colorVars';
import { removeTactic } from '../../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/removeTactic';
import { observer } from 'mobx-react-lite';
import { labelMap } from '../../../detailsUtils/tabMap';
import { useWebsocketStore } from '../../../../../../../../../stores/websocketStore/websocketProvider';
import { EditIcon } from '../../../../../../../../atomic/buttons/editIcon/EditIcon';
import { CancelOrderButton } from '../../../../../../../../atomic/buttons/cancelOrderButton/CancelOrderButton';
import { PlayButton } from '../../../../../../../../atomic/buttons/pauseButtons/PlayButton';
import { PauseButton } from '../../../../../../../../atomic/buttons/pauseButtons/PauseButton';
import { pauseExitTactic } from '../../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/pauseExitTactic';
const categoryColorMap = {
  Setup: colors.blue,
  'Setup Filter': colors.purple,
  Exit: colors.red,
  Entry: colors.green,
  Position: colors.orange,
};
const returnTacticId = (tacticName, category, tradePlan) => {
  switch (category) {
    case 'Setup':
      return tradePlan.setupDetails[tacticName].tacticId ?? null;
    case 'Setup Filter':
      return tradePlan.setupFilters[tacticName].tacticId ?? null;
    case 'Entry':
      return tradePlan.entryTactics[tacticName].tacticId ?? null;
    case 'Position':
      return tradePlan.positionTactics[tacticName].tacticId ?? null;
    case 'Exit':
      return tradePlan.exitTactics[tacticName].tacticId ?? null;
    default:
      return null;
  }
};

export const NotEngagedTacticRow = observer(
  ({ tradePlanId, category, tacticName, addTab, gcNoEditOrRemove }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId];
    const tacticId = returnTacticId(tacticName, category, tradePlan);
    const inPosition = tradePlan.inPosition;
    let pauseState = null;
    if (category === 'Exit' && tradePlan) {
      pauseState = tradePlan.exitTactics[tacticName]?.paused ?? null;
    }
    const openEditTab = () => {
      addTab(tacticName, category);
    };
    return (
      <tr className={style.row}>
        <td className={style.cell}>
          <Body3 fontWeight={600} color={categoryColorMap[category]}>
            {category}
          </Body3>
        </td>
        <td className={style.cell}>
          <Body3 fontWeight={600} color={colors.lightGrey}>
            {labelMap[tacticName]}
          </Body3>
        </td>
        {!gcNoEditOrRemove ? (
          <td
            style={{ color: colors.yellow }}
            className={style.buttonCell}
            onClick={openEditTab}
          >
            <div className={style.buttonWrapper}>
              <EditIcon width={18} height={18} color={colors.orange} />
            </div>
          </td>
        ) : (
          <td></td>
        )}
        {category === 'Exit' ? (
          <td
            style={{ color: colors.red }}
            className={style.buttonCell}
          >
            <div className={style.buttonWrapper}>
              <CancelOrderButton
                width={18}
                clickHandler={() => {
                  removeTactic(tradePlanId, tacticName, tacticId);
                }}
              />
            </div>
          </td>
        ) : (
          <td></td>
        )}

        {category === 'Exit' && inPosition ? (
          <td
            className={style.buttonCell}
            onClick={() => pauseExitTactic(tradePlanId, tacticId, !pauseState)}
          >
            <div className={style.buttonWrapper}>
              {pauseState ? (
                <PlayButton width={18} height={18} />
              ) : (
                <PauseButton width={18} height={18} />
              )}
            </div>
          </td>
        ) : (
          <td></td>
        )}
      </tr>
    );
  }
);
NotEngagedTacticRow.defaultProps = {
  gcNoEditOrRemove: false,
};

NotEngagedTacticRow.propTypes = {
  addTab: PropTypes.func,
  category: PropTypes.any,
  rowColor: PropTypes.any,
  tacticName: PropTypes.any,
  tradePlanId: PropTypes.any,
};
